<app-pan-modal #addModal (modalClose)="clearInputs()">
  <div header>Add User</div>

  <div body class="flex flex-col gap-2">
    <app-pan-form-control>
      <app-pan-floating-label>New User Name</app-pan-floating-label>
      <input type="text" [(ngModel)]="newUserName" (keyup)="cleanUsername()" panInput placeholder="First Last" />
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>New User Email</app-pan-floating-label>
      <input type="text" [(ngModel)]="newUserEmail" panInput placeholder="name@domain.com" />
    </app-pan-form-control>
  </div>

  <div footer>
    <app-pan-button
      class="me-2 mb-2"
      [color]="'primary'"
      (click)="addNewUser()"
      [disabled]="!canAddNewUser() || submittingNewUser()"
      [state]="submittingNewUser() ? 'loading' : 'default'"
      icon="add"
    >
      Add New User
    </app-pan-button>
  </div>
</app-pan-modal>
